import React from 'react';
import TableHeader from '../TableHeader';
import moment from 'moment';

const WalletsList = ({
  wallets
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Wallets list</h2>
          <p className='MainHeader__left__p'>Total {wallets.length.toLocaleString()} wallets</p>
        </div>
      </div>

      <div className='Table Table--wallet-list'>
        {(() => {
          let columnHeaders = [
            {
              label: 'Id',
              sortKey: 'id'
            },
            {
              label: 'Wallet address'
            },
            {
              label: 'Yay user id'
            },
            {
              label: 'Created at',
              sortKey: 'created_at'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {wallets.map((wallet) => (
          <div className='Table__row' key={wallet.id} data-x={wallet}>
            <div className='Table__col'>
              {wallet.id}
            </div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={wallet.bagId ? `/${gon.currentProvider}/bag/${wallet.bagId}` : `/${gon.currentProvider}/wallet/${wallet.id}`}
              >
                {wallet.walletAddress}
              </a>
            </div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/yay/users/${wallet.yayUserId}`}
              >
                {wallet.yayUserId}
              </a>
            </div>
            <div className='Table__col'>
              {moment(wallet.createdAt).format('YYYY-MM-DD HH:mm')}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default WalletsList;
